import store from "../store";

export const authActionTypes = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  ADD_AUTH_INFO: "ADD_AUTH_INFO"
};

export function login(email, password) {
  store.dispatch({
    type: authActionTypes.LOGIN,
    payload: { email, password }
  });
}

export function logout() {
  store.dispatch({
    type: authActionTypes.LOGOUT
  });
}

export function addAuthInfo(data) {
  store.dispatch({
    type: authActionTypes.ADD_AUTH_INFO,
    payload: data
  });
}
